import { ChangeEvent, MouseEvent, RefObject } from 'react'

import { KTIcon } from '../../../../../_metronic/helpers'
import { RECEIPT_ACCEPT } from './useReceiptActions'

interface Props {
  fileInputRef: RefObject<HTMLInputElement>
  isUploading: boolean
  onClick: (e: MouseEvent<HTMLButtonElement>) => void
  onFileSelect: (e: ChangeEvent<HTMLInputElement>) => void
}

/**
 * Кнопка «Прикрепить чек» — одна на активную очередь, завершённые и журнал диспутов.
 *
 * Показывается только там, где у тикета ещё нет файла: правило «один чек на тикет» общее,
 * повторная загрузка отбивается бэкендом с 409.
 */
export const ReceiptUploadButton = ({ fileInputRef, isUploading, onClick, onFileSelect }: Props) => (
  <div className='flex flex-column'>
    <input
      ref={fileInputRef}
      type='file'
      accept={RECEIPT_ACCEPT}
      onChange={onFileSelect}
      style={{ visibility: 'hidden', width: 0, height: 0 }}
      disabled={isUploading}
    />
    <button
      type='button'
      className={`btn ${!isUploading ? `btn-icon` : ``} btn-bg-light btn-active-color-primary btn-sm`}
      title={`Прикрепить чек`}
      disabled={isUploading}
      onClick={onClick}
    >
      {!isUploading ? (
        <KTIcon className={`fs-1`} iconName='file-up' />
      ) : (
        <span className='d-flex' style={{ alignItems: 'center' }}>
          <span className='spinner-border spinner-border-sm align-middle me-2'></span>
          Загрузка...
        </span>
      )}
    </button>
  </div>
)
